import { IconSwitch } from "../../../components/IconSwitch/IconSwitch";
import { Matrix } from "../../../components/Matrix/Matrix";
import { InternalGradeChips } from "../InternalGradesChips/InternalGradesChips";
import { StyledMatrixContent } from "./MatrixBox.styled";
import { ReactComponent as GlobeIcon } from "../../../icons/globe.svg";
import { ReactComponent as CollaboratorIcon } from "../../../icons/users.svg";
import { ReactComponent as InternalGradeIconIcon } from "../../../icons/internalGrade.svg";
import {
  InternalGradeStats,
  MatrixItem,
} from "../../../types/api/potentialMatrix.type";
import { PotentialMatrixFilters } from "../../../hooks/usePotentialMatrixFilters.hook";
import { PotentialMatrixFilterKeyEnum } from "../../../types/api/filters.type";
import { CollaboratorInfo } from "../../../types/AppTypes";
import { MatrixDetails } from "../MatrixDetails/MatrixDetails";
import {
  COLLABORATORS_LABEL,
  GLOBAL_LABEL,
  INTERNAL_GRADE_LABEL,
} from "../../../constants/Dictionary";
import { MatrixCalibrationProps } from "../../../components/MatrixGrid/MatrixGrid";
import { MatrixSizes } from "../../../constants/PotentialMatrixConstants";
import { MatrixViewMode } from "../PotentialMatrix";

type MatrixBoxProps = {
  selectedViewMode: MatrixViewMode;
  setSelectedViewMode: (mode: MatrixViewMode) => void;
  data: MatrixItem[];
  filters: PotentialMatrixFilters;
  loading: boolean;
  handleFilters: (
    key: PotentialMatrixFilterKeyEnum,
    value: PotentialMatrixFilters[PotentialMatrixFilterKeyEnum],
  ) => void;
  onClickResume: (collaborator: CollaboratorInfo) => void;
  onCloseDetails: () => void;
  matrixItem?: MatrixItem;
  onClickMatrixItem?: (item: MatrixItem) => void;
  calibration?: MatrixCalibrationProps;
  potentialMatrixStatsData: InternalGradeStats[];
  loadingPotentialMatrixStats?: boolean;
  showDetailsChip?: boolean;
};

const MatrixBox = ({
  selectedViewMode,
  setSelectedViewMode,
  data,
  loading,
  filters,
  matrixItem,
  onClickMatrixItem,
  handleFilters,
  onClickResume,
  onCloseDetails,
  calibration,
  potentialMatrixStatsData,
  loadingPotentialMatrixStats,
  showDetailsChip = true,
}: MatrixBoxProps) => {
  return (
    <StyledMatrixContent>
      <div
        className="filters-container"
        style={{
          justifyContent:
            selectedViewMode !== MatrixViewMode.GLOBAL
              ? "space-between"
              : "flex-end",
        }}
      >
        <InternalGradeChips
          visible={selectedViewMode !== MatrixViewMode.GLOBAL}
          value={filters.internalGrade}
          onChange={(value) =>
            handleFilters(PotentialMatrixFilterKeyEnum.INTERNAL_GRADE, value)
          }
          type={filters.type.value}
          potentialMatrixStatsData={potentialMatrixStatsData}
          loadingPotentialMatrixStats={loadingPotentialMatrixStats}
        />
        <IconSwitch
          options={[
            {
              value: MatrixViewMode.GLOBAL,
              icon: <GlobeIcon />,
              tooltipLabel: GLOBAL_LABEL,
            },
            {
              value: MatrixViewMode.INTERNAL_GRADE,
              icon: <InternalGradeIconIcon />,
              tooltipLabel: INTERNAL_GRADE_LABEL,
            },
            {
              value: MatrixViewMode.COLLABORATOR,
              icon: <CollaboratorIcon />,
              tooltipLabel: COLLABORATORS_LABEL,
            },
          ]}
          selectedOption={selectedViewMode}
          setSelectedOption={setSelectedViewMode}
          disabled={!!matrixItem}
        />
      </div>
      {matrixItem ? (
        <MatrixDetails
          item={matrixItem}
          onClose={onCloseDetails}
          filters={filters}
          yearSelected={Number(filters.year)}
          onClickResume={onClickResume}
          matrixData={data ?? []}
        />
      ) : (
        <Matrix
          yearSelected={Number(filters.year)}
          data={data ?? []}
          onClickItem={onClickMatrixItem}
          size={MatrixSizes.BIG}
          selectedItem={matrixItem}
          loading={loading}
          viewMode={selectedViewMode}
          onClickResume={onClickResume}
          matrixCalibration={calibration}
          showDetailsChip={showDetailsChip}
        />
      )}
    </StyledMatrixContent>
  );
};

export default MatrixBox;
